import { Typography } from '@vivaldis/antd-ui'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { WorkPermit } from './components/WorkPermit'

export const FormContent: FC = () => {
  const [t] = useTranslation('web_ui')
  return (
    <>
      <Typography.Title level={5} marginBottom={16}>
        {t(
          'edit_employee_personal_information_form.steps.add_work_permit.section_header'
        )}
      </Typography.Title>
      <WorkPermit />
    </>
  )
}
